export default [
  {
    path: '/back-office/courtiers',
    name: 'back-office-courtiers',
    component: () => import('@/views/back-office/courtiers/Courtiers.vue'),
  },
  {
    path: '/back-office/assureurs',
    name: 'back-office-assureurs',
    component: () => import('@/views/back-office/assureurs/AssureursParent.vue'),
  },
  {
    path: '/back-office/extraction',
    name: 'back-office-extraction',
    component: () => import('@/views/back-office/extraction/Extraction.vue'),
  },
  {
    path: '/back-office/statistiques/sessions',
    name: 'back-office-statistiques-sessions',
    component: () => import('@/views/back-office/statistiques/Sessions.vue'),
  },
  {
    path: '/back-office/risque',
    name: 'back-office-risque',
    component: () => import('@/views/back-office/risque/Risque.vue'),
  },
  {
    path: '/back-office/guide',
    name: 'back-office-guide',
    component: () => import('@/views/back-office/guide/MetierGuide.vue'),
  },
  {
    path: '/back-office/carousels',
    name: 'back-office-carousels',
    component: () => import('@/views/back-office/carousels/Carousels.vue'),
  },
  {
    path: '/back-office/webinars',
    name: 'back-office-webinars',
    component: () => import('@/views/back-office/webinars/MasterWebinarAtelier.vue'),
  },
  {
    path: '/back-office/gestion',
    name: 'back-office-gestion',
    component: () => import('@/views/back-office/gestion/gestionParent.vue'),
  },
  {
    path: '/back-office/getstion-bordereau-bbi',
    name: 'back-office-getstion-bordereauBBI',
    component: () => import('@/views/back-office/gestion/gestion-bordereaux/List.vue'),
  }

]
